"use client";

import ReactSparkle from "react-sparkle";

type SparklesProps = {
  colors?: string[];
  minSize?: number;
  maxSize?: number;
  count?: number;
  fadeOutSpeed?: number;
};

const Sparkles = ({
  colors = ["#b37e1b", "#e4c351", "#ededed", "#987618", "#e4b81c", "#d57521"],
  count = 10,
  maxSize = 12,
  minSize = 7,
  fadeOutSpeed = 30,
}: SparklesProps) => {
  return (
    <span className="sparkles">
      <ReactSparkle
        color={colors}
        count={count}
        minSize={minSize}
        maxSize={maxSize}
        fadeOutSpeed={fadeOutSpeed}
        flicker={false}
      />
    </span>
  );
};

export default Sparkles;
